import React, { useCallback, useMemo, useEffect } from 'react'
import classnames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import dateUtils from 'shared/src/date'
import icons from 'icons'

import DatePicker from './DatePicker'

const FastNextIcon = icons.fastNext
const FastPreviousIcon = icons.fastPrevious
const NextIcon = icons.next
const PreviousIcon = icons.previous

const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttons: {
    padding: theme.spacing(2),
  },
  datePicker: {
    marginTop: '0px',
  },
  picker: {
    '& label': {
      left: '35px',
      whiteSpace: 'nowrap',
    },
    '& input': {
      textAlign: 'center',
    },
  },
}))

const DateNavigator = ({
  label = "Click to change the date",
  value,
  disablePast,
  navigatorButtons,
  min,
  max,
  condensed,
  condensedDates,
  className,
  onMove,
  onChange,
}) => {
  const classes = useStyles()

  const theme = useTheme()
  const isLarge = useMediaQuery(theme.breakpoints.up('md'))

  const shouldDisableDate = useCallback((dt) => {
    if(!condensed) return false
    return condensedDates.indexOf(dateUtils.dateToString(dt)) < 0
  }, [
    condensed,
    condensedDates,
  ])

  const back = (
    <div className={ classes.buttons }>
      {
        !condensed && (
          <IconButton
            disabled={ navigatorButtons.back ? false : true }
            onClick={ () => onMove(-7) }
          >
            <FastPreviousIcon />
          </IconButton>
        )
      }
      <IconButton
        disabled={ navigatorButtons.back ? false : true }
        onClick={ () => onMove(-1) }
      >
        <PreviousIcon />
      </IconButton>
    </div>
  )

  const forward = (
    <div className={ classes.buttons }>
      <IconButton
        disabled={ navigatorButtons.forward ? false : true }
        onClick={ () => onMove(1) }
      >
        <NextIcon />
      </IconButton>
      {
        !condensed && (
          <IconButton        
            disabled={ navigatorButtons.forward ? false : true }  
            onClick={ () => onMove(7) }
          >
            <FastNextIcon />
          </IconButton>
        )
      }
    </div>
  )

  return (
    <div>
      <div className={ classes.row }>
        {
          isLarge && (
            back
          )
        }
        <div className={ classes.datePicker }>
          <DatePicker
            disablePast={ disablePast }
            min={ min }
            max={ max }
            shouldDisableDate={ shouldDisableDate }
            className={ classnames(classes.picker, className) }
            label={ label }
            value={ value }
            onChange={ onChange }
          />
        </div>
        {
          isLarge && (
            forward
          )
        }
      </div>
      {
        !isLarge && (
          <div className={ classes.row }>
            {
              back
            }
            {
              forward
            }
          </div>
        )
      }
    </div>
  )
}

export default DateNavigator